import React from "react";
import styles from "./styles.module.css";
import { Spacing } from "spacing/component";
import { Button3 } from "components/buttons/Button3";
import { TextBody1 } from "fonts/Body1";
import { Flex } from "components/containers/Flex";

interface Props {
  onMoreDetailsClick?: () => void;
  onGotItClick?: () => void;
}

export const CookiePolicyDialog = ({
  onMoreDetailsClick,
  onGotItClick
}: Props) => (
  <div className={styles.component}>
    <Spacing p="s">
      <Flex alignItemsCenter>
        <TextBody1>
          We use cookies to ensure you get the best experience on our site.
        </TextBody1>
        <Spacing pl="l" />
        <button onClick={onMoreDetailsClick}>
          <TextBody1 underlined bold>
            More details
          </TextBody1>
        </button>
        <Spacing pl="4xl" />
        <Button3 text="Got It" onClick={onGotItClick} />
      </Flex>
    </Spacing>
  </div>
);
